import { useCallback, useEffect, useMemo, useState } from "react";
import { useLoading } from "shared/contexts/Loading";
import apiCall from "shared/services/ApiAdapter";

/**
 * Fetch assignments with JHipster-compatible filters using the common ApiAdapter.
 * Supported filters: studentId, batchId, evaluationId, page, size
 */
const useAssignments = (filters = {}) => {
  const { startLoading, stopLoading } = useLoading();
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const queryString = useMemo(() => {
    const params = new URLSearchParams();
    if (filters.studentId != null) {
      params.append("studentId.equals", String(filters.studentId));
    }
    if (filters.batchId != null) {
      params.append("batchId.equals", String(filters.batchId));
    }
    if (filters.evaluationId != null) {
      params.append("evaluationId.equals", String(filters.evaluationId));
    }
    if (filters.page != null) {
      params.append("page", String(filters.page));
    }
    // Default size to 1000 unless explicitly provided
    params.append("size", String(filters.size != null ? filters.size : 1000));
    return params.toString();
  }, [JSON.stringify({
    studentId: filters.studentId,
    batchId: filters.batchId,
    evaluationId: filters.evaluationId,
    page: filters.page,
    size: filters.size,
  })]);

  const fetchAssignments = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiCall(
        `/assignments?${queryString}`,
        false,
        "GET",
        null,
        startLoading,
        stopLoading,
        () => {}
      );
      const list = Array.isArray(data) ? data : data?.content ?? [];
      setAssignments(list);
    } catch (err) {
      console.error("Error fetching assignments:", err);
      setError(err);
      setAssignments([]);
    } finally {
      setLoading(false);
    }
  }, [queryString, startLoading, stopLoading]);

  useEffect(() => {
    fetchAssignments();
  }, [fetchAssignments]);

  return { assignments, loading, error, refetch: fetchAssignments };
};

export default useAssignments;


